<template>
  <span class="track" :class="{ on: checked }" @click="$emit('change', !checked)">
    <span class="knob" />
  </span>
</template>

<script>
export default {
  name: 'SwitchToggle',
  props: {
    checked: { type: Boolean, default: false }
  },
  emits: ['change']
}
</script>

<style scoped>
.track {
  width: 44px;
  height: 26px;
  border-radius: var(--radius-pill);
  flex-shrink: 0;
  background: var(--sand-300);
  position: relative;
  transition: var(--transition-base);
  cursor: pointer;
  display: inline-block;
}
.track.on { background: var(--seth-gold); }
.knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: var(--shadow-xs);
  transition: var(--transition-base);
}
.track.on .knob { left: 21px; }
</style>
